// Hocs
import asyncRoute from '../AsyncRoute'

import { SOIL_JOBS_ROUTE_URLS } from '../constants'
import getRequestName from '../components/getRequestName'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-soil-jobs-dom').SoilJobsManager
      const requestInfoMaskHoc = require('fc-requests').requestInfoMaskHoc
      const requestInfo$ = require('fc-requests').getFilteredRequestsInProgress$(SOIL_JOBS_ROUTE_URLS)

      resolve(requestInfoMaskHoc({
        requestInfo$,
        getRequestName,
      })(View))

      /* Webpack named bundle */
    }, 'jobs')
  })
}

export default asyncRoute({getComponent, reducers: []})
